import React from "react";

type Props = {
  className?: string;
};

export const DownloadIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M8 11L3 6H6V1H10V6H13L8 11Z" fill="currentColor" />
      <path d="M2 13H14V15H2V13Z" fill="currentColor" />
    </svg>
  );
};
